<div class="card">
  <div class="back-nav">
    <button mat-stroked-button (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      Administration Centre de Compétence
    </button>
  </div>

  <div class="data-header">

    <button mat-raised-button color="primary" (click)="openDialog()">
       Nouvelle catégorie
    </button>

    <mat-form-field appearance="outline" class="filter-field">
      <mat-label>Rechercher</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Nom de la catégorie...">
    </mat-form-field>

    <button mat-stroked-button color="primary" (click)="exportData()">
  <mat-icon>file_download</mat-icon> Exporter
</button>

  </div>

  <mat-table
    class="mat-elevation-z8 table-container"
    [dataSource]="dataSource"
    matSort
    (matSortChange)="announceSortChange($event)">

    <!-- Nom -->
    <ng-container matColumnDef="nom">
      <mat-header-cell *matHeaderCellDef mat-sort-header>Nom</mat-header-cell>
      <mat-cell *matCellDef="let row">{{ row.nom }}</mat-cell>
    </ng-container>

    <!-- Actions -->
    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef class="actions-td">Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="actions-td">

        <button mat-icon-button
                (click)="openDialog(row)"
                matTooltip="Modifier"
                color="primary">
          <mat-icon>mode_edit</mat-icon>
        </button>

        <button mat-icon-button
                (click)="deleteCategorie(row)"
                matTooltip="Supprimer"
                color="warn">
          <mat-icon>delete</mat-icon>
        </button>

      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
        <mat-icon>search_off</mat-icon>
        Aucune catégorie trouvée
      </td>
    </tr>

  </mat-table>
</div>